export default "<p>structure works!</p>\n";